export class Presentation {
    id:number = 0;
    name:string = '';
}
